export default "__VITE_ASSET__CWhYFZ$z__"